import React, { useState, useEffect } from 'react';
import { Leaf } from 'lucide-react';
import { API } from '../contexts/AuthContext';

// Shows the cached photo for an item (herb/oil/recipe) via the image-bytes
// endpoint. Falls back to a soft leaf placeholder if not generated yet.
export default function ItemPhoto({ itemId, alt = '', className = '', imgClassName = '' }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [itemId]);

  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-botanica-greenLight ${className}`}>
        <Leaf className="w-6 h-6 text-botanica-green/60" />
      </div>
    );
  }

  return (
    <div className={`overflow-hidden bg-botanica-greenLight ${className}`}>
      <img
        src={`${API}/illustration/${encodeURIComponent(itemId)}/image`}
        alt={alt}
        loading="lazy"
        onError={() => setFailed(true)}
        className={`w-full h-full object-cover ${imgClassName}`}
      />
    </div>
  );
}
